import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ListaFaltantes } from "../list/faltan";
type Entity = models.MatrizDistancias;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un MatrizDistancias
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Distancia: validation.required,
        IdSucursalA: validation.required,
        IdSucursalB: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class MatrizDistanciasFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    faltantes = observeResource(resources.MatrizDistancias.ParesFaltantes);

    handleOnFaltanteClick = (x: models.ParSucursalMatrizDistancia) => {
        this.props.onChange({
            ... this.props.value,
            IdSucursalA: x.IdSucursalA,
            IdSucursalB: x.IdSucursalB
        });
    }

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Number = getField(kea.Number);
        const Sucursal = getField(selectores.Sucursal);

        return (
            <div>
                <kea.Title titulo="Matriz de distancias" onRegresar={() => history.go("/catalogos/MatrizDistancias")} />
                <ListaFaltantes value={this.faltantes} onClick={this.handleOnFaltanteClick} />
                {kea.autogrid(3, [
                    <Sucursal field="IdSucursalA" label="Sucursal A" />,
                    <Sucursal field="IdSucursalB" label="Sucursal B" />,
                    <Number field="Distancia" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const MatrizDistanciasForm = componentToRx(MatrizDistanciasFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matrizdistancias/edit/form.tsx